import { render } from "./icons-calendar-check.svg?vue&type=template&id=89ebd728?inline"
const script = {}
script.render = render

export default script